import {
  CREATE_SALESFORCE_ACCOUNT,
  DELETE_SALESFORCE_ACCOUNT,
  GET_SALESFORCE_ACCOUNT_BY_ID,
  GET_SALESFORCE_ACCOUNT_HISTORY,
  GET_SALESFORCE_ACCOUNTS,
  UPDATE_SALESFORCE_ACCOUNT
} from 'services/query/SalesforceAccounts.queries';
import {
  CREATE_SALESFORCE_ACCOUNT_RW_BUNDLE,
  GENERATE_SALESFORCE_ACCOUNT_SURVEY_LINK,
  GET_SALESFORCE_ACCOUNT_RW_BUNDLE_CONTEXT,
  GET_SALESFORCE_ACTIVITIES,
  GET_SALESFORCE_EMAIL_TEMPLATES,
  GET_RENDERED_TEMPLATE_BY_ID,
  GET_SALESFORCE_ORG_WIDE_EMAIL_ADDRESSES,
  LOG_SALESFORCE_CALL,
  SEND_SALESFORCE_EMAIL,
  UPDATE_SALESFORCE_CALL_NOTES
} from 'services/query/SalesforceLeads.queries';
import { UseQueryType } from 'types/hooks';
import {
  GetRWBundleContextResponse,
  SalesforceAccountDetailResponse,
  SalesforceAccountHistoryResponse,
  SalesforceAccountsResponse,
  SalesforceActivitiesResponse,
  GetRenderedTemplateByIdResponse,
  SalesforceEmailTemplateFilter,
  SalesforceEmailTemplatesResponse,
  SalesforceOrgWideEmailAddressesResponse
} from 'types/SalesforceAccounts.types';

import {
  UseGraphQlMutation,
  UseGraphQlQuery,
  UsegraphQlLazyQuery
} from './hooks';

const defaultConfig = {};

export const useGetSalesforceAccountsList: UseQueryType<
  SalesforceAccountsResponse
> = (config = defaultConfig) =>
  UseGraphQlQuery(GET_SALESFORCE_ACCOUNTS, config);

// Backward compatible alias for any existing imports.
export const useGetSalesforceAccounts = useGetSalesforceAccountsList;

export const useGetSalesforceAccountById: UseQueryType<
  SalesforceAccountDetailResponse
> = (config = defaultConfig) =>
  UseGraphQlQuery(GET_SALESFORCE_ACCOUNT_BY_ID, config);

export const useGetSalesforceAccountHistory: UseQueryType<
  SalesforceAccountHistoryResponse
> = (config = defaultConfig) =>
  UseGraphQlQuery(GET_SALESFORCE_ACCOUNT_HISTORY, config);

export const useCreateSalesforceAccount = (config = defaultConfig) =>
  UseGraphQlMutation(CREATE_SALESFORCE_ACCOUNT, config);

export const useUpdateSalesforceAccount = (config = defaultConfig) =>
  UseGraphQlMutation(UPDATE_SALESFORCE_ACCOUNT, config);

export const useDeleteSalesforceAccount = (config = defaultConfig) =>
  UseGraphQlMutation(DELETE_SALESFORCE_ACCOUNT, config);

export const useGetSalesforceActivities: UseQueryType<
  SalesforceActivitiesResponse
> = (config = defaultConfig) =>
  UseGraphQlQuery(GET_SALESFORCE_ACTIVITIES, config);

export const useGetSalesforceOrgWideEmailAddresses = (config = defaultConfig) =>
  UsegraphQlLazyQuery<
    SalesforceOrgWideEmailAddressesResponse,
    Record<string, never>
  >(GET_SALESFORCE_ORG_WIDE_EMAIL_ADDRESSES, config);

export const useGetSalesforceEmailTemplates = (config = defaultConfig) =>
  UsegraphQlLazyQuery<
    SalesforceEmailTemplatesResponse,
    { filter?: SalesforceEmailTemplateFilter }
  >(GET_SALESFORCE_EMAIL_TEMPLATES, config);

export const useGetRenderedTemplateById = (config = defaultConfig) =>
  UsegraphQlLazyQuery<
    GetRenderedTemplateByIdResponse,
    { id: string; recipientId: string; relatedRecordId: string }
  >(GET_RENDERED_TEMPLATE_BY_ID, config);

export const useSendSalesforceEmail = (config = defaultConfig) =>
  UseGraphQlMutation(SEND_SALESFORCE_EMAIL, config);

export const useLogSalesforceCall = (config = defaultConfig) =>
  UseGraphQlMutation(LOG_SALESFORCE_CALL, config);

export const useUpdateSalesforceCallNotes = (config = defaultConfig) =>
  UseGraphQlMutation(UPDATE_SALESFORCE_CALL_NOTES, config);

export const useGenerateSalesforceAccountSurveyLink = (
  config = defaultConfig
) => UseGraphQlMutation(GENERATE_SALESFORCE_ACCOUNT_SURVEY_LINK, config);

export const useCreateSalesforceAccountRwBundle = (config = defaultConfig) =>
  UseGraphQlMutation(CREATE_SALESFORCE_ACCOUNT_RW_BUNDLE, config);

export const useGetSalesforceAccountRwBundleContext = (
  config = defaultConfig
) =>
  UsegraphQlLazyQuery<GetRWBundleContextResponse, { accountId: string }>(
    GET_SALESFORCE_ACCOUNT_RW_BUNDLE_CONTEXT,
    config
  );
